import React from "react";
import "emoji-mart/css/emoji-mart.css";
import { Picker } from "emoji-mart";

const VmoEmojiPicker = (props) => {
  return <Picker {...props} />;
};
export default VmoEmojiPicker;
